<template>
  <v-container>
    <template v-if="_aplicacao != 'NAO_APLICAR'">
      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox 
            label="Incluir janela na data de imobilização?" 
            v-model="_janelaDataImob" 
            hide-details
            class="py-0 my-0"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox 
            label="Desconsiderar itens zerados ou negativos"
            v-model="_desconsiderarItensZeradosOuNegativos" 
            hide-details class="py-0 my-0"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox 
            label="Expurgar itens de Racionalização do COM"
            v-model="_expurgarItensRacionalizacaoCOM" 
            hide-details class="py-0 my-0"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto mt-2">
        <v-col cols="12" class="pb-0">
          <span style="color: #757575; font-size:15px;">Períodos para janelas de Data de Lançamento</span>
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col sm="4" cols="6">
          <v-text-field
            label="Nº de dias antes"
            v-model="_periodosDataLancamento.diasAntes"
            min="0" type="number" 
            @blur="(_periodosDataLancamento.diasAntes < 0) ? _periodosDataLancamento.diasAntes = 0 : 1"
          />
        </v-col>
        <v-col sm="4" cols="6">
          <v-text-field
            label="Nº de dias depois"
            v-model="_periodosDataLancamento.diasDepois"
            min="0" type="number" 
            @blur="(_periodosDataLancamento.diasDepois < 0) ? _periodosDataLancamento.diasDepois = 0 : 1"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pt-0">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header style="font-weight: 300; font-size: 15px;">
                Períodos por Tipologia Aneel
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size:13px;">Redes Aéreas</span>
                  </v-col>

                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias antes"
                      v-model="_periodosDataLancamento.diasAntesRedesAereas"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasAntesRedesAereas < 0) ? _periodosDataLancamento.diasAntesRedesAereas = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias depois"
                      v-model="_periodosDataLancamento.diasDepoisRedesAereas"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasDepoisRedesAereas < 0) ? _periodosDataLancamento.diasDepoisRedesAereas = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox 
                      label="Aplicar período" 
                      v-model="_periodosDataLancamento.aplicarPeriodoRedesAereas"
                      hide-details 
                      class="py-0 my-0" 
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size:13px;">Redes Subterrâneas</span>
                  </v-col>
                  
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias antes"
                      v-model="_periodosDataLancamento.diasAntesRedesSubterraneas"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasAntesRedesSubterraneas < 0) ? _periodosDataLancamento.diasAntesRedesSubterraneas = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias depois"
                      v-model="_periodosDataLancamento.diasDepoisRedesSubterraneas"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasDepoisRedesSubterraneas < 0) ? _periodosDataLancamento.diasDepoisRedesSubterraneas = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox 
                      label="Aplicar período" 
                      v-model="_periodosDataLancamento.aplicarPeriodoRedesSubterraneas"
                      hide-details 
                      class="py-0 my-0" 
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size:13px;">Medidores</span>
                  </v-col>
                  
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias antes"
                      v-model="_periodosDataLancamento.diasAntesMedidores"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasAntesMedidores < 0) ? _periodosDataLancamento.diasAntesMedidores = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias depois"
                      v-model="_periodosDataLancamento.diasDepoisMedidores"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasDepoisMedidores < 0) ? _periodosDataLancamento.diasDepoisMedidores = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox 
                      label="Aplicar período" 
                      v-model="_periodosDataLancamento.aplicarPeriodoMedidores"
                      hide-details 
                      class="py-0 my-0" 
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size:13px;">Subestações</span>
                  </v-col>
                  
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias antes"
                      v-model="_periodosDataLancamento.diasAntesSubestacoes"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasAntesSubestacoes < 0) ? _periodosDataLancamento.diasAntesSubestacoes = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias depois"
                      v-model="_periodosDataLancamento.diasDepoisSubestacoes"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasDepoisSubestacoes < 0) ? _periodosDataLancamento.diasDepoisSubestacoes = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox 
                      label="Aplicar período" 
                      v-model="_periodosDataLancamento.aplicarPeriodoSubestacoes"
                      hide-details 
                      class="py-0 my-0" 
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="pb-0">
                    <span style="color: #757575; font-size:13px;">Linhas</span>
                  </v-col>
                  
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias antes"
                      v-model="_periodosDataLancamento.diasAntesLinhas"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasAntesLinhas < 0) ? _periodosDataLancamento.diasAntesLinhas = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="6">
                    <v-text-field
                      label="Nº de dias depois"
                      v-model="_periodosDataLancamento.diasDepoisLinhas"
                      min="0" type="number" 
                      @blur="(_periodosDataLancamento.diasDepoisLinhas < 0) ? _periodosDataLancamento.diasDepoisLinhas = 0 : 1"
                    />
                  </v-col>
                  <v-col sm="4" cols="12" align-self="center">
                    <v-checkbox 
                      label="Aplicar período" 
                      v-model="_periodosDataLancamento.aplicarPeriodoLinhas"
                      hide-details 
                      class="py-0 my-0" 
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>

export default {
  name: "SaneamentoVocFlagData",

  props: {
    aplicacao: {
      type: String,
      required: true
    },
    janelaDataImob: {
      type: Boolean,
      default: undefined
    },
    periodosDataLancamento: {
      type: Object,
      default: () => {}
    },
    desconsiderarItensZeradosOuNegativos: {
      type: Boolean,
      default: undefined
    },
    expurgarItensRacionalizacaoCOM: {
      type: Boolean,
      default: undefined
    },
  },

  computed: {
    _aplicacao: {
      get() {
        return this.aplicacao;
      },
      set(newValue) {
        this.$emit("update:aplicacao", newValue);
      }
    },
    _janelaDataImob: {
      get() {
        return this.janelaDataImob;
      },
      set(newValue) {
        this.$emit("update:janelaDataImob", newValue);
      }
    },
    _periodosDataLancamento: {
      get() {
        return this.periodosDataLancamento;
      },
      set(newValue) {
        this.$emit("update:periodosDataLancamento", newValue);
      }
    },
    _desconsiderarItensZeradosOuNegativos: {
      get() {
        return this.desconsiderarItensZeradosOuNegativos;
      },
      set(newValue) {
        this.$emit("update:desconsiderarItensZeradosOuNegativos", newValue);
      }
    },
    _expurgarItensRacionalizacaoCOM: {
      get() {
        return this.expurgarItensRacionalizacaoCOM;
      },
      set(newValue) {
        this.$emit("update:expurgarItensRacionalizacaoCOM", newValue);
      }
    },
  },
};
</script>

<style></style>
